import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeletePhotoUseCaseInterface } from 'domain/usecases';

export class RemoteDeletePhoto implements DeletePhotoUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<DeletePhotoUseCaseInterface.Result>,
  ) {}

  async execute(
    params: DeletePhotoUseCaseInterface.Params,
  ): Promise<DeletePhotoUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'delete',
      url: this.url + '/' + params.id,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
